module.exports = __webpack_public_path__ + "img/hugo1.9b33bb9f.jpg";